import { Trans, useTranslation } from 'react-i18next';

import { ExternalLink, Separator } from '~/components';
import { AnchorTargets } from '~/constants/url';

import { SettingsSection, SettingsSections } from '../components/SettingsSection';
import { AutoForwarding } from './AutoForwardingForm/AutoForwarding';
import { ExternalSystems } from './ExternalSystems/ExternalSystems';
import { Peppol } from './Peppol/Peppol';

export const Integrations = () => {
  const { t } = useTranslation(['settings']);

  return (
    <SettingsSections>
      <SettingsSection
        description={t('settings:integrations.peppol.description')}
        id={AnchorTargets.SETTINGS_INTEGRATIONS_PEPPOL}
        title={t('settings:integrations.peppol.title')}
      >
        <Peppol />
      </SettingsSection>

      <Separator />

      <SettingsSection
        description={<Trans components={{ a: <ExternalLink /> }} i18nKey="settings:integrations.forwarding.description" />}
        id={AnchorTargets.SETTINGS_INTEGRATIONS_AUTO_FORWARDING}
        title={t('settings:integrations.forwarding.title')}
      >
        <AutoForwarding />
      </SettingsSection>

      <Separator />

      <SettingsSection
        description={t('settings:integrations.externalSystems.description')}
        id={AnchorTargets.SETTINGS_INTEGRATIONS_EXTERNAL_SERVICES}
        title={t('settings:integrations.externalSystems.title')}
      >
        <ExternalSystems />
      </SettingsSection>
    </SettingsSections>
  );
};
